import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2 } from 'lucide-react';
import { cn } from './cn.js';
/**
 * Loading spinner with role="status" and a translatable accessible label.
 * The label MUST be passed in (translated by the app), never hardcoded here.
 */
export function Spinner({ label, className, ...props }) {
    return (_jsxs("div", { role: "status", className: cn('inline-flex items-center', className), ...props, children: [_jsx(Loader2, { className: "size-5 animate-spin text-muted-foreground motion-reduce:animate-none", "aria-hidden": "true" }), _jsx("span", { className: "sr-only", children: label })] }));
}
